import request from '@/sheep/request';

const DictApi = {
  // 根据字典类型查询字典数据信息
  getDictDataListByType: (type) => {
    return request({
      url: `/system/dict-data/type`,
      method: 'GET',
      params: {
        type,
      },
      custom: {
        isToken: false, // 不携带token，避免用户类型不匹配错误
        showError: false,
        showLoading: false,
      },
    });
  },
};

export default DictApi;
